import { BaseModel, supreme } from '@/supreme-core'
import util from '@/util/util'
import hybrid from '@/util/nativeHybrid'

const envInfo = util.getEnvInfo('cosmosConfig')
class CosmosModel extends BaseModel {
	constructor(config) {
		config.timeout = 15000

		config.baseURL = config.baseURL || envInfo.baseUrl + envInfo.application + '/' + config.api
		super(config)
	}
	// 给接口传设备信息
	getMobileinfo() {
		let Info = hybrid.getOSInfo()
		if (Info) {
			return JSON.stringify(Info)
		} else {
			return JSON.stringify({ brand: 'web', model: 'web', os: 'web' })
		}
	}
	getToken() {
		return util.getToken()
	}
	post(param) {
		if (!param) {
			param = {}
		}
		let config = {}
		config.headers = {
			mobileinfo: this.getMobileinfo()
			//   "mobileinfo":JSON.stringify({
			//   "version":"8.0.0",
			//   "channel":"dev",
			//   "device_type":"android",
			//   "device_model":"HWI-AL00",
			//   "device_id":"7529116c7bbde737",
			//   "device_brand":"HUAWEI",
			//   "network_type":"wifi",
			//   "is_iphonex_type":false,
			//   "is_full_screen":false,
			//   "ip_address":"unknown_ip",
			//   "os_lang":"zh",
			//   "os_timezone":"CN"
			// })
		}

		if (this.getToken()) {
			param['accessToken'] = this.getToken()
		}

		if (param.data) {
			param.data = JSON.stringify(param.data)
		}
		return super.post(param, config)
	}
	get(data) {
		const config = {
			headers: {
				'MK-Sign-Verified': true,
				Authorization: `Bearer ` + this.getToken()
			}
		}
		return super.get(data, config)
	}
}
export default CosmosModel
